// Copyright (c) Microsoft. All rights reserved.

interface ITabViewProps {
    title: string;
    showDescription: boolean;
    children?: React.ReactNode;
}

export const TabView: React.FC<ITabViewProps> = ({ title, showDescription, children }) => {
    return (
        <div className="flex-1 overflow-y-auto bg-slate-100 leading-6 shadow-md dark:bg-slate-900 sm:leading-7 p-6">
            <h1 className="mb-3 text-2xl">{title}</h1>
            {showDescription && (
                <div className="mb-5">
                    To include your own documents, use the upload button below. This will allow you to query against the
                    content using Azure Open AI GPT.
                </div>
            )}
            {children}
        </div>
    );
};
